module.exports = __webpack_public_path__ + "img/xian_center.a00dfec9.jpg";